// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__124YH","right":"styles_right__9Iw1o"};